const dict = {
  uk: {
    // Header + navigation
    toDashboard: 'В кабінет',
    backHome: 'На головну',
    toShop: 'До магазину',
    backToCatalog: 'Назад до каталогу',
    title: 'Магазин навчальних матеріалів',
    // Search / filters
    searchPlaceholder: 'Пошук за назвою або артикулом',
    filters: 'Фільтри',
    clearAll: 'Скинути все',
    category: 'Категорія',
    topic: 'Тема',
    priceUAH: 'Ціна (грн)',
    priceFrom: 'Від',
    priceTo: 'До',
    sort: 'Сортування',
    sortDefault: 'За замовчуванням',
    sortPriceAsc: 'Від дешевих до дорогих',
    sortPriceDesc: 'Від дорогих до дешевих',
    itemsFound: 'Знайдено товарів:',
    // Categories
    catWorkbook: 'Воркбук',
    catFlashcards: 'Картки',
    catMerch: 'Мерч',
    // Icons / tooltips
    wishlist: 'Обране',
    goToCart: 'Перейти до кошика',
    // Login modal
    loginRequired: 'Увійдіть в акаунт',
    loginWishlistPrompt: 'Щоб додати товар в обране, необхідно увійти в акаунт',
    cancel: 'Скасувати',
    login: 'Увійти',
    // Product detail
    loading: 'Завантаження...',
    notFound: 'Товар не знайдено',
    notFoundHint: 'Можливо, товар був видалений або переміщений',
    goBack: 'Повернутися назад',
    sku: 'Код товару:',
    priceUah: 'грн',
    inStock: 'В наявності',
    outOfStock: 'Немає в наявності',
    quantity: 'Кількість:',
    price: 'Ціна:',
    addedToCart: 'Додано в кошик!',
    addToCart: 'Додати в кошик',
    features: 'Особливості:',
    specs: 'Характеристики:',
    photoAlt: 'Фото {{index}}',
    // Cart / Wishlist drawer + catalog
    cart: 'Кошик',
    cartEmpty: 'Кошик порожнiй',
    cartEmptyHint: 'Додайте товари з каталогу',
    outOfStockWarning: 'Деякі товари закінчились. Вони не будуть включені в замовлення.',
    itemUnavailable: 'Товар недоступний',
    total: 'Разом:',
    checkout: 'Оформити замовлення',
    noItemsInStock: 'Немає товарів в наявності',
    wishlistTitle: 'Обране',
    wishlistEmpty: 'Список обраного порожній',
    wishlistEmptyHint: 'Натисніть серце на товарі, щоб додати',
    toCart: 'В кошик',
    catalogSubtitle: 'Воркбуки, картки для вивчення слів та фірмовий мерч для ефективного навчання',
    alreadyInCart: 'Вже в кошику',
  },
  en: {
    toDashboard: 'To dashboard',
    backHome: 'Back to home',
    toShop: 'To shop',
    backToCatalog: 'Back to catalog',
    title: 'Learning materials shop',
    searchPlaceholder: 'Search by name or SKU',
    filters: 'Filters',
    clearAll: 'Clear all',
    category: 'Category',
    topic: 'Topic',
    priceUAH: 'Price (UAH)',
    priceFrom: 'From',
    priceTo: 'To',
    sort: 'Sort',
    sortDefault: 'Default',
    sortPriceAsc: 'Price: low to high',
    sortPriceDesc: 'Price: high to low',
    itemsFound: 'Items found:',
    catWorkbook: 'Workbook',
    catFlashcards: 'Flashcards',
    catMerch: 'Merch',
    wishlist: 'Wishlist',
    goToCart: 'Go to cart',
    loginRequired: 'Sign in',
    loginWishlistPrompt: 'Sign in to add items to your wishlist',
    cancel: 'Cancel',
    login: 'Sign in',
    loading: 'Loading...',
    notFound: 'Product not found',
    notFoundHint: 'The product may have been removed or moved',
    goBack: 'Go back',
    sku: 'SKU:',
    priceUah: 'UAH',
    inStock: 'In stock',
    outOfStock: 'Out of stock',
    quantity: 'Quantity:',
    price: 'Price:',
    addedToCart: 'Added to cart!',
    addToCart: 'Add to cart',
    features: 'Features:',
    specs: 'Specifications:',
    photoAlt: 'Photo {{index}}',
    cart: 'Cart',
    cartEmpty: 'Your cart is empty',
    cartEmptyHint: 'Add items from the catalog',
    outOfStockWarning: 'Some items are out of stock and will not be included in the order.',
    itemUnavailable: 'Item unavailable',
    total: 'Total:',
    checkout: 'Place order',
    noItemsInStock: 'No items in stock',
    wishlistTitle: 'Wishlist',
    wishlistEmpty: 'Your wishlist is empty',
    wishlistEmptyHint: 'Tap the heart on an item to add it',
    toCart: 'To cart',
    catalogSubtitle: 'Workbooks, flashcards, and branded merch for effective learning',
    alreadyInCart: 'Already in cart',
  },
};

export default dict;
